import React from 'react';
import Polymathy from '../components/Polymathy';

const PolymathyPage = () => {
  return <Polymathy />;
};

export default PolymathyPage;

